/**
 * The special purpose of an entity
 */
export enum EntitySpecialPurpose {
  /**
   * Used for commercial purposes.
   */
  Commercial = 'commercial',

  /**
   * Associated with research initiatives.
   */
  Research = 'research',

  /**
   * Used for testing purposes.
   */
  Testing = 'testing',

  /**
   * Used for demonstration purposes.
   */
  Demonstration = 'demonstration',
}
